import { Directive, ElementRef, inject, input, OnInit, ViewContainerRef } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

/**
 * Shows a spinner in place of a button's label while `appLoadingButton` is true. The look lives in
 * `libs/shared/styles/src/base.css`: the label is faded out, not removed, so the button keeps its
 * size and its accessible name, and the spinner takes the label's colour.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appLoadingButton]',
  host: {
    class: 'seiri-loading-button',
    '[class.seiri-loading-button--loading]': 'appLoadingButton()',
    '[attr.aria-busy]': 'appLoadingButton() || null',
  },
})
export class LoadingButtonDirective implements OnInit {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef)
  private readonly vcr = inject(ViewContainerRef)

  readonly appLoadingButton = input<boolean>(false)

  ngOnInit(): void {
    const spinner = this.vcr.createComponent(MatProgressSpinner)
    spinner.setInput('diameter', 20)
    spinner.setInput('mode', 'indeterminate')

    const spinnerEl = spinner.location.nativeElement as HTMLElement
    spinnerEl.classList.add('seiri-loading-button__spinner')
    spinnerEl.setAttribute('aria-hidden', 'true')
    this.host.nativeElement.appendChild(spinnerEl)
  }
}
